import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsAudienceControlEnabled } from '../../selectors/experiments/selectIsAudienceControlEnabled';
import { PaginationContainer as PaginationContainerOld } from '../../serp/components/pagination/container';
import { useApplicationContext } from '../../utils/applicationContext';
import { PaginationSectionContainer as PaginationContainerNew } from './PaginationSectionContainer';

export function PaginationContainer() {
  const { config } = useApplicationContext();
  const isPermanentControlGroup = useSelector(selectIsAudienceControlEnabled);
  const isNewPaginationEnabledConfig = config.get<boolean>('serp.newPagination');
  const isNewPaginationEnabled = React.useMemo(
    () => Boolean(isNewPaginationEnabledConfig) && !isPermanentControlGroup,
    [isNewPaginationEnabledConfig, isPermanentControlGroup],
  );

  return isNewPaginationEnabled ? <PaginationContainerNew /> : <PaginationContainerOld />;
}
